interface User {
    id: string,
    login: string
}

/** Ошибка входа/регистрации. isNetwork=true — сервер недоступен (нет связи);
 *  иначе message содержит причину с сервера (detail), напр. «Неверный пароль». */
export class AuthError extends Error {
    isNetwork: boolean;
    constructor(message: string, isNetwork = false) {
        super(message);
        this.isNetwork = isNetwork;
    }
}

async function readDetail(response: Response): Promise<string> {
    try {
        const body = await response.json();
        return (body && body.detail) ? String(body.detail) : "";
    } catch {
        return "";
    }
}

/**
 * Проверка на авторизированного пользователя
 */
export const apiMe = async (): Promise<any> => {
    try {
        const response = await fetch('/me', {method: 'GET'});

        if (!response.ok) {
            console.error(`Ошибка ${response.status}`);
            return null;
        }

        return await response.json();
    } catch (err) {
        console.error('Запрос не удался', err);
        return null;
    }
}


/**
 * Регистрация пользователя
 */
export const apiRegistration = async (login: string, password: string): Promise<User> => {
    let response: Response;
    try {
        response = await fetch('/registration', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ login, password })
        });
    } catch (err) {
        console.error('Запрос не удался', err);
        throw new AuthError('', true); // нет связи
    }

    if (!response.ok) {
        const detail = await readDetail(response);
        console.error(`Ошибка ${response.status}: ${detail}`);
        throw new AuthError(detail, false); // причина с сервера
    }

    return await response.json() as User;
}


/**
 * Авторизация пользователя
 */
export const apiAuth = async (login: string, password: string): Promise<User> => {
    let response: Response;
    try {
        response = await fetch('/auth', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ login, password })
        });
    } catch (err) {
        console.error('Запрос не удался', err);
        throw new AuthError('', true); // нет связи
    }

    if (!response.ok) {
        const detail = await readDetail(response);
        console.error(`Ошибка ${response.status}: ${detail}`);
        throw new AuthError(detail, false); // причина с сервера
    }

    return await response.json() as User;
}



/**
 * Выход из аккаунта
 */
export const apiLogout = async (): Promise<boolean> => {
    try {
        const response = await fetch('/logout', {method: 'POST'});
        if (!response.ok) {
            console.error(`Не удалось выйти из аккаунта \n ${response.status}`);
            return false;
        }
        return true;
    } catch (err) {
        console.error(`Не удалось выйти из аккаунта \n ${err}`);
        return false;
    }
}